module.exports = "/_next/static/images/background-ellipse-26665ed121473bf79f2b4456cf277c6d.png";